import DrawingActions from '../actions/DrawingActions';
import DrawingService from '../services/DrawingService';

const defaultState = {
    inProgressDrawings: [],
};

function DrawingReducer(state = defaultState, action) {
    switch (action.type) {
    case DrawingActions.Types.UPDATE_IN_PROGRESS_DRAWINGS: {
        let inProgressDrawings = state.inProgressDrawings;
        const hasExistingDrawing = !!DrawingService.getInProgressDrawingForItem(action.contentRevisionId, inProgressDrawings);

        const newDrawing = {
            contentRevisionId: action.contentRevisionId,
            drawing: action.drawing,
            isOpen: false,
        };

        if (hasExistingDrawing) {
            inProgressDrawings = DrawingService.filterOutInProgressDrawingsById(action.contentRevisionId, state.inProgressDrawings);
        }

        inProgressDrawings.push(newDrawing);

        return {
            ...state,
            inProgressDrawings,
        };
    }
    case DrawingActions.Types.REMOVE_IN_PROGRESS_DRAWING: {
        const filteredInProgressDrawings = DrawingService.filterOutInProgressDrawingsById(action.contentRevisionId, state.inProgressDrawings);
        return {
            ...state,
            inProgressDrawings: filteredInProgressDrawings,
        };
    }
    default:
        return state;
    }
}

export default DrawingReducer;
